const BatchStatusEnum = {
    0: "Beklemede",
    1: "Çalışıyor",
    2: "Tamamlandı",
    '-1': "Hata",
}

export default BatchStatusEnum;
